/**
 * Product listing change view script
 */
class MM_productListing {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.changeViewWrapper = $('.change-view');
        this.listView = this.changeViewWrapper.parent().find('.products');
        this.blockIcon = this.changeViewWrapper.find('.block');
        this.listIcon = this.changeViewWrapper.find('.list');
    }

    initEvents() {
        if (this.changeViewWrapper.length) {
            this.listIcon.on('click', e => {
                e.preventDefault();
                this.listIcon.addClass('is-active');
                this.blockIcon.removeClass('is-active');
                this.listView.addClass('use-list-view').removeClass('use-block-view');
                window.localStorage.setItem('list-view', 'list');
            });

            this.blockIcon.on('click', e => {
                e.preventDefault();
                this.blockIcon.addClass('is-active');
                this.listIcon.removeClass('is-active');
                this.listView.addClass('use-block-view').removeClass('use-list-view');
                window.localStorage.setItem('list-view', 'block');
            });

            if (window.localStorage.getItem('list-view')) {
                if (window.localStorage.getItem('list-view') === 'block') {
                    this.changeViewWrapper.find('a').removeClass('is-active');
                    this.blockIcon.addClass('is-active');
                    this.listView.addClass('use-block-view').removeClass('use-list-view');
                }
            
                if (window.localStorage.getItem('list-view') === 'list') {
                    this.changeViewWrapper.find('a').removeClass('is-active');
                    this.listIcon.addClass('is-active');
                    this.listView.addClass('use-list-view').removeClass('use-block-view');
                }
            } else {
                this.changeViewWrapper.find('a').removeClass('is-active');
                this.blockIcon.addClass('is-active');
                this.listView.addClass('use-block-view').removeClass('use-list-view');
            }         
        }

        $(document).ajaxComplete((event, xhr, settings) => {
            this.changeViewWrapper = $('.change-view');

            if (!this.changeViewWrapper.length || !settings || !settings.url || settings.url.indexOf('/kategoria-produktu/') === -1) {
                return;
            }

            this.listView = this.changeViewWrapper.parent().find('.products');
            this.blockIcon = this.changeViewWrapper.find('.block');
            this.listIcon = this.changeViewWrapper.find('.list');

            if (window.localStorage.getItem('list-view')) {
                if (window.localStorage.getItem('list-view') === 'block') {
                    this.changeViewWrapper.find('a').removeClass('is-active');
                    this.blockIcon.addClass('is-active');
                    this.listView.addClass('use-block-view').removeClass('use-list-view');
                }
            
                if (window.localStorage.getItem('list-view') === 'list') {
                    this.changeViewWrapper.find('a').removeClass('is-active');
                    this.listIcon.addClass('is-active');
                    this.listView.addClass('use-list-view').removeClass('use-block-view');
                }
            } else {
                this.changeViewWrapper.find('a').removeClass('is-active');
                this.blockIcon.addClass('is-active');
                this.listView.addClass('use-block-view').removeClass('use-list-view');
            } 
        });
    }
}
